import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { IAppState } from '../state/app.state';
import { Store } from '@ngrx/store';
import {
  GetTotRace,
  ETotRaceActions,
  GetTotRaceSuccess,
  StopGetTotRace,
} from '../actions/totrace.actions';
import { switchMap, map, startWith, mapTo, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { RaceService } from 'src/app/service/http/race/race.service';
import { ITotrace } from 'src/app/models/totrace.interface';
import { interval, of, Subject } from 'rxjs';
import { PageLoadingHide } from '../actions/page.actions';

@Injectable()
export class TotraceEffects {
  flag = true;
  stop$: Subject<boolean> = new Subject<boolean>();

  
  getTotRace$ = createEffect(() => this._action$.pipe(
    ofType<GetTotRace>(ETotRaceActions.GetTotRace),
    switchMap((action) => interval(10000).pipe(takeUntil(this.stop$), startWith(0), mapTo(action))),
    switchMap((action) => this._raceService.getTot(action.payload)),
    distinctUntilChanged(
      (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr) && this.flag
    ),
    switchMap((totrace: ITotrace) => {
      this.flag = true;
      return of(new GetTotRaceSuccess(totrace), new PageLoadingHide());
    })
  ));

  
  topGetTotRace$ = createEffect(() => this._action$.pipe(
    ofType<StopGetTotRace>(ETotRaceActions.StopGetTotRace),
    map(() => {
      this.stop$.next(true);
      this.flag = false;
    })
  ), { dispatch: false });

  constructor(private _raceService: RaceService, private _action$: Actions) {}
}
